<template>
  <ticket-management
    :show-create="false"
    @change="fetchData"
  >
    <div>
      <SeverityBoxes />
    </div>
  </ticket-management>
</template>

<script>
export default {
  components: {
    ticketManagement: () =>
      import(
        "@/views/modules/charging-management/ticket-management-and-reports/Index.vue"
      ),
    SeverityBoxes: () => import("./utils/SeverityBoxes.vue"),
  },

  methods: {
    fetchData(obj) {
      const params = { ...obj };
      this.$store.dispatch("ticketManagement/sla_statics", params).then(() => {
        // if (this.options.page > (this.meta?.lastPage || 1)) {
        //   this.options.page = 1;
        // }
      });
    },
  },
};
</script>
